import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-u', 'LetterU', [["path",{"d":"M8 7v7.5a2.5 2.5 0 0 0 2.5 2.5H13a2.5 2.5 0 0 0 2.5-2.5V7","key":"svg-0"}]]);